import HomepageTemplate from "gatsby-theme-carbon/src/templates/Homepage";
import blueGradient from "../../../../src/videos/slat_gradient_loop.mp4";
import { featureCard, videoCard, rowSpacing } from "../../../../src/styles/index.module.scss";
import * as React from 'react';
export default {
  HomepageTemplate,
  blueGradient,
  featureCard,
  videoCard,
  rowSpacing,
  React
};